module.exports = __webpack_public_path__ + "static/img/S.704010f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hunter/S.png
// module id = ViYW
// module chunks = 0